export const fr = {
    'nav.today': "Aperçu Aujourd'hui",
    'nav.calendar': "Calendrier Demande",
    'nav.rates': "Tarifs & Règles",
    'nav.automation': "Automation",
    'nav.audit': "Journal d'Audit",
    'nav.settings': "Paramètres",
    'sidebar.status': "Connecté",
    'stat.occupancy': "Occupation",
    'stat.adr': "ADR (Tarif Moyen)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Revenu Est.",
    'stat.trend.vsLastWeek': "vs sem. dern.",
    'stat.trend.onPace': "Sur la voie",
    'dashboard.actions.title': "Actions Recommandées",
    'dashboard.actions.empty': "Aucune action trouvée.",
    'filter.all': "Tout",
    'filter.pricing': "Prix",
    'filter.restriction': "Restrictions",
    'action.approve': "Approuver",
    'action.reject': "Rejeter",
    'action.risk.low': "risque faible",
    'action.risk.medium': "risque moyen",
    'action.risk.high': "risque élevé",
    'action.label.current': "Actuel",
    'action.label.proposed': "Proposé",
    'action.metric.impact': "Impact",
    'action.metric.why': "Pourquoi",
    'action.status.executed': "Auto-Exécuté",
    'header.search': "Rechercher...",
    'header.logout': "Déconnexion",
    'auto.level.title': "Niveau Autopilote",
    'auto.level.manual': "Manuel",
    'auto.level.manual.desc': "Vous approuvez chaque recommandation.",
    'auto.level.assisted': "Assisté",
    'auto.level.assisted.desc': "Auto-approuver risque faible. Réviser changements majeurs.",
    'auto.level.auto': "Entièrement Auto",
    'auto.level.auto.desc': "L'IA gère les prix 24/7 selon vos limites.",
    'auto.level.active': "Actif",
    'auto.guardrails.title': "Limites de Sécurité",
    'auto.guardrails.maxIncrease': "Hausse Max. Journalière",
    'auto.guardrails.maxIncrease.desc': "Éviter les chocs de prix.",
    'auto.guardrails.maxDecrease': "Baisse Max. Journalière",
    'auto.guardrails.maxDecrease.desc': "Éviter le dumping accidentel.",
    'auto.guardrails.minRate': "Tarif Plancher",
    'auto.guardrails.minRate.desc': "Ne jamais vendre sous ce prix (Netto).",
    'auto.emergency.title': "Contrôle d'Urgence",
    'auto.emergency.label': "Arrêt d'Urgence",
    'auto.emergency.desc': "Pause immédiate de toute l'automatisation.",
    'auto.emergency.btn': "PAUSER LE SYSTÈME",
    'rates.filter.all': "Tous les Types",
    'rates.filter.next14': "14 Prochains Jours",
    'rates.export': "Exporter",
    'audit.table.time': "Heure",
    'audit.table.actor': "Acteur",
    'audit.table.category': "Catégorie",
    'audit.table.action': "Action",
    'audit.table.details': "Détails",
    'audit.table.status': "Statut",
    'settings.pms.title': "Connexion PMS",
    'settings.pms.connected': "Connecté à",
    'settings.pms.disconnect': "Déconnecter",
    'settings.account.title': "Compte",
    'settings.account.role': "Rôle",
    'settings.restart': "Redémarrer Onboarding",
    'onboard.title': "Connecter PMS",
    'onboard.desc': "Sélectionnez votre système de gestion (PMS) pour synchroniser.",
    'onboard.connecting': "Connexion...",
    'onboard.connect': "Connecter",
    'onboard.success.title': "Configuration Terminée !",
    'onboard.success.desc': "**SynthHotel Berlin** est maintenant synchronisé.",
    'onboard.success.sub': "Importé 3 types de chambres, 14 plans tarifaires et 243 réservations.",
    'onboard.btn.dashboard': "Aller au Tableau de Bord",
    'action.dynamic.weekend.title': "Augmenter Tarif Week-end",
    'action.dynamic.weekend.desc': "Occup. > 75% Samedi, forte demande (+12 ch. en 24h).",
    'action.dynamic.minstay.title': "Activer Séjour Min 2 Nuits",
    'action.dynamic.minstay.desc': "Concert Taylor Swift annoncé. Éviter séjours d'une nuit.",
    'action.dynamic.distress.title': "Baisser Tarif (Faible Demande)",
    'action.dynamic.distress.desc': "Occup. 35% Mardi prochain. Concurrents ont baissé de 10€.",
    'action.dynamic.gap.title': "Combler Vide : Retirer CTA",
    'action.dynamic.gap.desc': "Nuit isolée dispo. Retirer 'Fermé à l'arrivée' pour vendre.",
};
